import * as types from './mutation-types'
import {api} from '@/service/api'

export const actions = {
  async getHomeInfo ({commit}) {
    let res = await api.home.getHomeInfo()
    if (res.success) {
      commit(types.INIT_HOME, res.data)
    }
  },
  async businessList ({commit}) {
    let res = await api.home.businessList()
    if (res.success) {
      commit(types.INIT_BUSINESS, res.data)
    }
  },
  async noticeList ({commit},o) {
    let res = await api.home.noticeList(o)
    if (res.success) {
      commit(types.INIT_NOTICE, res.data)
      return res;
    }
  },
  async actList ({commit},o) {
    const params = {
      sortStatus:o.sortStatus
    }  
    let res = await api.home.actList(params)
    if (res.success) {
      return res
    }
  },
  async actDetail ({commit},o) {
    let res = await api.home.actDetail(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },     
  async noticeDetail ({commit},o) {
    let res = await api.home.noticeDetail(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },  
  async getSystemStatus ({dispatch}, o) {
    let res = await api.home.getSystemStatus()
    if (res.success) {
      return res
    }
  },  
  async customerCenter ({dispatch}, o) {
    let res = await api.home.customerCenter()
    if (res.success) {
      return res
    }
  },        
  async noticeLast ({commit},o) {
    let res = await api.home.noticeLast(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },   
}



// WEBPACK FOOTER //
// ./src/logic/home/actions.js